import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    cardElementWrapper: {
      border: `1px solid ${theme.colorTokens.outlineVariant}`,
      maxWidth: '400px',
    },
    buttonWrapper: {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    button: {
      borderRadius: '40px',
      fontWeight: 600,
      boxShadow: 'none',
      textTransform: 'uppercase',
      minWidth: '130px',
      display: 'inline-block',
      '&:not(:first-of-type)': {
        marginLeft: '5px',
      },
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '110px',
      },
    },
    error: {
      fontSize: '12px',
      color: theme.palette.error.main,
      textAlign: 'center',
    },
    paymentWrapper: {
      maxWidth: '400px',
      margin: 'auto',
    },
    boxWrapper: {
      position: 'relative',
      textAlign: 'center',
    },
    boxDecorator: {
      backgroundColor: theme.colors.common4,
      position: 'absolute',
      height: '2px',
      top: '45%',
      left: 0,
      right: 0,
    },
    boxText: {
      display: 'inline-block',
      position: 'relative',
      color: theme.colors.common4,
      padding: theme.spacing(0, 2),
      backgroundColor: theme.colors.common11,
    },
  };
};
